module.exports = __webpack_public_path__ + "img/byte.ba38152e.png";